export default "__VITE_ASSET__gTdkQ7RK__"